import React, { useEffect, useReducer } from "react";

const CustomerAuthContext = React.createContext();

const INITIAL_STATE = {
  phoneNumber: "",
  addresses: {},
  name: "",
  email: "",
};

const initializer = (path) => (initialValue = INITIAL_STATE) => {
  const json = JSON.parse(localStorage.getItem(path));
  return json || initialValue;
};

const customerReducer = (state, action) => {
  switch (action.type) {
    case "SET_PHONE_NUMBER": {
      const newState = { ...state };
      newState.phoneNumber = action.phoneNumber;
      return newState;
    }
    case "SET_NAME": {
      const newState = { ...state };
      newState.name = action.name;
      return newState;
    }
    case "SET_EMAIL": {
      const newState = { ...state };
      newState.email = action.email;
      return newState;
    }
    case "ADD_ADDRESS": {
      const newState = { ...state };
      const addresses = { ...newState.addresses };
      addresses[action.payload.uid] = action.payload.data;
      newState.addresses = addresses;
      return newState;
    }
    case "UPDATE_ADDRESS": {
      const newState = { ...state };
      const addresses = { ...newState.addresses };
      addresses[action.payload.uid] = {
        ...addresses[action.payload.uid],
        ...action.payload.data,
      };
      newState.addresses = addresses;
      return newState;
    }
    case "DELETE_ADDRESS": {
      let newState = { ...state };
      delete newState.addresses[action.uid];
      return newState;
    }
    // case "CLEAR": {
    //   return INITIAL_STATE.customer;
    // }
    case "RESET_ORDER":
      return action.payload.customer;
    default:
      return state;
  }
};

const REDUCER_PATH = "resto-guru-customer";

export default function CustomerAuthProvider({ children }) {
  const [customer, dispatch] = useReducer(
    customerReducer,
    INITIAL_STATE,
    initializer(REDUCER_PATH)
  );

  useEffect(() => {
    if (customer) localStorage.setItem(REDUCER_PATH, JSON.stringify(customer));
  }, [customer]);

  return (
    <CustomerAuthContext.Provider value={[customer, dispatch]}>
      {children}
    </CustomerAuthContext.Provider>
  );
}

export const useCustomer = () => React.useContext(CustomerAuthContext);
